export default "__VITE_ASSET__CxWwhWWC__"